module.exports = __webpack_public_path__ + "fonts/Lora-Regular--72631269e4dc9b244bfb441ea22188fe.72631269e4dc9b244bfb441ea22188fe.ttf";